import revive_payload_client_4sVQNw7RlN from "/codebuild/output/src3921127278/src/Conversational-bot/client/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import router_jmwsqit4Rs from "/codebuild/output/src3921127278/src/Conversational-bot/client/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/codebuild/output/src3921127278/src/Conversational-bot/client/node_modules/nuxt/dist/app/plugins/payload.client.js";
import components_plugin_KR1HBZs4kY from "/codebuild/output/src3921127278/src/Conversational-bot/client/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "/codebuild/output/src3921127278/src/Conversational-bot/client/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import prefetch_client_5tzzN0oIVL from "/codebuild/output/src3921127278/src/Conversational-bot/client/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/codebuild/output/src3921127278/src/Conversational-bot/client/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes
]